import { useTranslation } from "react-i18next";
import notSupported from "@Assets/images/notSupported.svg";

export default function OldBrowserWarning() {
  const { t } = useTranslation();
  return (
    <div className="fixed top-0 z-50 flex h-full w-full flex-col items-center justify-center bg-white">
      <img src={notSupported} />
      <p>{t("Please update your browser")}</p>
    </div>
  );
}
